/** Browser download helper. Tries File System Access API; falls back to <a download>. */
export async function triggerDownload(blob: Blob, suggestedName: string) {
  type FsWindow = Window & {
    showSaveFilePicker?: (opts: unknown) => Promise<unknown>;
  };
  const w = window as FsWindow;
  if (typeof w.showSaveFilePicker === "function") {
    try {
      const handle = (await w.showSaveFilePicker({
        suggestedName,
        types: [
          {
            description:
              suggestedName.split(".").pop()?.toUpperCase() ?? "File",
            accept: {
              [blob.type || "application/octet-stream"]: [
                "." + (suggestedName.split(".").pop() ?? "bin"),
              ],
            },
          },
        ],
      })) as {
        createWritable: () => Promise<{
          write: (b: Blob) => Promise<void>;
          close: () => Promise<void>;
        }>;
      };
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();
      return;
    } catch (e) {
      if ((e as { name?: string }).name === "AbortError") return;
      // fall through to anchor download
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = suggestedName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
